import { render, staticRenderFns } from "./ss-field.vue?vue&type=template&id=4456ce89"
import script from "./ss-field.vue?vue&type=script&lang=js"
export * from "./ss-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports